import { __extends } from "tslib";
import React from 'react';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { jsStyles } from './TopBar.styles';
/**
 * Разделитель в топбаре
 *
 * @visibleName TopBar.Divider
 */

var TopBarDivider =
/** @class */
function (_super) {
  __extends(TopBarDivider, _super);

  function TopBarDivider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TopBarDivider.prototype.render = function () {
    var _this = this;

    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this.theme = getAddonsTheme(theme);
      return React.createElement(ThemeContext.Provider, {
        value: _this.theme
      }, _this.renderMain());
    });
  };

  TopBarDivider.prototype.renderMain = function () {
    return React.createElement("span", {
      className: jsStyles.divider(this.theme)
    });
  };

  TopBarDivider.__KONTUR_REACT_UI__ = 'TopBarDivider';
  return TopBarDivider;
}(React.Component);

export { TopBarDivider };